<template>
    <div>
        <Breadcrumbs main="matchTx.dashboard" title="homePageAgent.header" />
        <b-container fluid>   
          <div class="card">
            <div class="d-flex flex-row justify-content-start ml-5">
                <h2 class="text-dark ml-2">{{ compNameLocal }}</h2>
            </div>  
            <div class="block-diagram">
                <div
                    style="top: 65px; left:150px;"
                    class="blockTx gradient-wb"
                    v-b-popover.hover.top="$t('homePageAgent.agentBookingTxAction')" 
                >
                    <img :src = "require('../../assets/images/homePage/eBooking.png')" alt="Block Image" class="block-imageBooking" />
                    <p class="text-center" style="font-size: 18px;">{{ $t('homePage.custBookingTxInfo') }}</p>
                    <button @click="handleClickAgentBookingTx"  class="block-button btn-lg">{{ $t('homePage.custBookingTx') }}</button>
                </div>
                <div
                    style="top: 65px; left:580px;"
                    class="blockTx gradient-wg"
                    v-b-popover.hover.top="$t('homePageAgent.matchingAction')" 
                >
                    <img :src = "require('../../assets/images/homePage/matchingTx.png')" alt="Matching Image" class="block-imageMatching" />
                    <p class="text-center" style="font-size: 18px;">{{ $t('homePageAgent.matchingInfo')}}</p>
                    <button @click="handleClickShipApproval" class="block-button btn-lg">{{ $t('homePageAgent.matching') }}</button>
                </div>
                <div
                    style="top: 78px; left:1000px;"
                    class="blockTx gradient-wo"
                    v-b-popover.hover.top="$t('shipShore.actShipShoreAcceptMsg')" 
                >
                    <feather type="tag" size="40" class="mx-2"></feather>
                    <p class="text-center" style="font-size: 18px;">{{ $t('shipShore.shoreApproval')}}</p>
                    <button @click="handleClickShipShore" class="block-button btn-lg"  > {{$t('homePageAgent.shoreApproval')}}</button>
                </div>                
                <svg class="connecting-lines">
                    <line
                    v-for="(line, index) in lines"
                    :key="index"
                    :x1="line.x1"
                    :y1="line.y1"
                    :x2="line.x2"
                    :y2="line.y2"
                    class= "line"
                    />
                    <defs>
                    <marker 
                        id="arrowhead"
                        markerWidth="10"
                        markerHeight="7"
                        refX="9"
                        refY="3.5"
                        orient="auto"
                    >
                        <polygon points="0 0, 10 3.5, 0 7" class="arrowhead" />
                    </marker>
                    </defs>
                </svg>
            </div>            
          </div>

        </b-container>
    </div>

  </template>

  <script>
      import {getData } from "../../firebase"
      export default {
    data() {
      return {
        compNameLocal: '',
        balanced : 0,
        cc: '',
        lines: [

            { x1: 490, y1: 150, x2: 580, y2: 150 },            
            { x1: 920, y1: 150, x2: 1000, y2: 150 },
     
        ],
      };
    },
    mounted(){
        this.compId = localStorage.getItem("compId")
        getData("Company", "compId", this.compId, (res)=>{
            this.compNameLocal = res[0].compNameLocal
        })
    },
    methods: {
      handleClickAgentBookingTx() {
        this.$router.push('/eBooking/agentBookingTx')
      },
      handleClickShipApproval() {
        this.$router.push('/dashboard/shipApproval')
      },      
      handleClickShipShore() {
        this.$router.push('/process/shipShore')
      },      
    },
  };
  </script>
  
  <style scoped>
 .card{
    width: 100%;
    height: 400px;
    padding:10px;
    border-radius: 30px;
    background: linear-gradient(135deg, yellow, rgb(0, 107, 128));
}
  .block-diagram {
    position: relative;
    width: 100%;
    height: 190px;
  }
  
  .block {
    position: absolute;
    text-align: center;
    border: 1px solid #ccc;
    padding: 10px;
    background-color: #f9f9f9;
  }
  .blockTx {
    position: absolute;
    text-align: center;
    border: 1px solid #ccc;
    padding: 10px;
    background-color: #f9f9f9;
    border-radius: 300px;
  }


  .block-image {
    width: 30px;
    height: 100px;
  }

  .block-imageBooking {
    width: 320px;
    height: 60px;
  }
  .block-imageMatching {
    width: 320px;
    height: 60px;
  }
  .block-button {
    padding: 5px 10px;
    background-color: #007bff;
    color: white;
    border: none;
    cursor: pointer;
  }
  
  .block-button:hover {
    background-color: #0056b3;
  }
  
  .connecting-lines {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
  }
  
  .line {
    stroke: #0e1cded7;
    stroke-width: 2;
    marker-end: url(#arrowhead);
    stroke-dasharray: 5, 5; /* Creates a dotted line */
    stroke-dashoffset: 10; /* Initial offset */
    animation: run-dot 1s linear infinite;
  }
  .lineNoArH {
    stroke: #0e1cded7;
    stroke-width: 2;
    stroke-dasharray: 5, 5; /* Creates a dotted line */
    stroke-dashoffset: 10; /* Initial offset */
    animation: run-dot 1s linear infinite;
  }
  .arrowhead {
    fill: #000;
  }

@keyframes run-dot {
  to {
    stroke-dashoffset: 0; /* Moves the dots along the line */
  }
}
.gradient-yg {
   background: linear-gradient(135deg, yellow, green);
 }
 .gradient-wy {
   background: linear-gradient(135deg, white, yellow);
 }
 .gradient-wo {
   background: linear-gradient(135deg, white, orange);
 }
 .gradient-wb {
   background: linear-gradient(135deg, white, rgb(147, 184, 235));
 }
 .gradient-wg {
   background: linear-gradient(45deg, white, rgb(6, 238, 37));
 }

 .gradient-gw {
   background: linear-gradient(45deg, rgb(6, 238, 37), white);
 }
  </style>